import React, { useEffect, useState } from "react";
import '../../components/styles/FABBusinessDetails.css';
import { Button } from "antd";
import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";
import { API_BASE_URL_AGENT_DEV } from "../../services/apiConfig";

interface FABBusinessDetailsProps {
    setCarddetailmodalOpen: (open: boolean) => void;
    businessdata: any;
}

const FABBusinessDetails: React.FC<FABBusinessDetailsProps> = ({ setCarddetailmodalOpen, businessdata }) => {
    const [orderDetails, setOrderDetails] = useState<any[]>([]);

    useEffect(() => {
        if (businessdata?.fnbContractSeq) {
            console.log("가져온값 : " + businessdata?.fnbContractSeq);
            console.log("가져온값 list : " + JSON.stringify(businessdata, null, 2));

            fetchBusinessDetailsData(businessdata?.fnbContractSeq);
        }
    }, [businessdata]);

    const fetchBusinessDetailsData = async (fnbContractSeq: number) => {
        try {
            const response = await fetch(
                `${API_BASE_URL_AGENT_DEV}/fnb/contracts/order-history/${fnbContractSeq}`,
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );
            const data = await response.json();
            console.log("data json : " + JSON.stringify(data.data, null, 2));
            setOrderDetails(data.data); // 가져온 데이터를 상태에 저장
        } catch (error) {
            console.error("(ExcelUpload) Error fetching data:", error);
        }
    };

    return (
        <div className="layout">
            <div className="transaction-header">
                <span className="back-button" onClick={() => setCarddetailmodalOpen(false)}>&lt;</span>
            </div>

            <div className="transaction-header">
                | {businessdata?.consumerClubName} 의 거래중인 내역입니다.
            </div>
            <div className="button-group">
                <Button>전체</Button>
                <Button>최신순</Button>
                <Button>당일</Button>
                <Button>미결제</Button>
            </div>

            {/* 주문 상세 내역 */}
            {orderDetails.map((detail, index) => {
                let orderedMenu = [];

                // orderedMenu가 문자열일 때만 JSON 파싱 시도
                if (typeof detail.orderedMenu === 'string') {
                    try {
                        orderedMenu = JSON.parse(detail.orderedMenu).order;
                    } catch (error) {
                        console.error('Error parsing orderedMenu:', error);
                    }
                } else {
                    orderedMenu = detail.orderedMenu?.order || [];
                }

                // 모든 소비자의 consumerChecked 값이 true 인지 확인
                const allConsumersChecked = detail.fnbOrderConsumerList.every((consumer: { consumerChecked: any; }) => consumer.consumerChecked);

                return (
                    <div key={index} className="details">
                        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
                            <div
                                style={{
                                    backgroundColor: allConsumersChecked ? '#CDEFF7' : '#D3D3D3',
                                    color: allConsumersChecked ? '#007B97' : '#000',
                                    borderRadius: '15px',
                                    padding: '8px',
                                    marginRight: '16px',
                                }}
                            >
                                {allConsumersChecked ? "사용 완료" : "대기"}
                            </div>

                            <div style={{ marginRight: '16px' }}>
                                {new Date(detail.created).toLocaleString('ko-KR', {
                                    year: '2-digit',
                                    month: '2-digit',
                                    day: '2-digit',
                                    hour: '2-digit',
                                    minute: '2-digit',
                                })}
                            </div>

                            <div style={{ marginLeft: 'auto', textAlign: 'right', color: "#2D5478", fontSize: "18px" }}>
                                {detail.totalPrice.toLocaleString()}원
                            </div>
                        </div>

                        {/* 메뉴 목록 출력 */}
                        {orderedMenu.map((item: any, idx: number) => (
                            <div key={idx} className="details-item">
                                {item.name} ({item.price.toLocaleString()}원) * {item.count}개
                            </div>
                        ))}

                        {/* 주문자 목록 출력 */}
                        <div>
                            {detail.fnbOrderConsumerList.map((consumer: any, idx: number) => (
                                <span key={idx}>
                                    {consumer.consumerName}
                                    {consumer.consumerChecked ? (
                                        <CheckCircleOutlined style={{ marginLeft: '4px', color: 'green' }} />
                                    ) : (
                                        <CloseCircleOutlined style={{ marginLeft: '4px', color: 'red' }} />
                                    )}
                                </span>
                            ))}
                        </div>

                        {index < orderDetails.length - 1 && (
                            <hr style={{ border: '1px solid lightgray', margin: '16px 0' }} />
                        )}
                    </div>
                );
            })}
        </div>
    );
};

export default FABBusinessDetails;
